const CONTENT_ACTIONS = {
  CONTENT_TYPES_LOADED: 'CONTENT_TYPES_LOADED',
  CONTENT_TYPES_UPDATED: 'CONTENT_TYPES_UPDATED',
  CONTENT_TYPE_UPDATED: 'CONTENT_TYPE_UPDATED',
  CONTENT_READONLY_MODE: 'CONTENT_READONLY_MODE',
  CONTENT_EDIT_MODE: 'CONTENT_EDIT_MODE',
  CONTENT_MODELS_LOADED: 'CONTENT_MODELS_LOADED',
  CALENDAR_EVENTS_LOADED: 'CALENDAR_EVENTS_LOADED',
  APP_THEMES_LOADED: 'APP_THEMES_LOADED',
  SCREEN_DESIGNER_MODE: 'SCREEN_DESIGNER_MODE',
  SCREEN_DESIGNER_CONTENT: 'SCREEN_DESIGNER_CONTENT',
  CUSTOM_ROUTE_MODE: 'CUSTOM_ROUTE_MODE',
  CUSTOM_ROUTE_CONTENT: 'CUSTOM_ROUTE_CONTENT',
  DATA_SCENARIO_LOADED: 'DATA_SCENARIO_LOADED',
  DATA_SCENARIO_CLEARED: 'DATA_SCENARIO_CLEARED',
  INSERT_CODE_EDITOR_CONTENT: 'INSERT_CODE_EDITOR_CONTENT',
  CLEAR_CODE_EDITOR_INSERT: 'CLEAR_CODE_EDITOR_INSERT',
  CODE_INSERT_REQUESTED: 'CODE_INSERT_REQUESTED'
};

const insertCodeEditorContentAction = content => {
  return {
    type: CONTENT_ACTIONS.INSERT_CODE_EDITOR_CONTENT,
    payload: content
  };
};

const clearCodeEditorInsertAction = content => {
  return {
    type: CONTENT_ACTIONS.CLEAR_CODE_EDITOR_INSERT,
    payload: ''
  };
};

const codeEditorInsertRequested = () => {
  return {
    type: CONTENT_ACTIONS.CODE_INSERT_REQUESTED,
    payload: ''
  };
};

const dataScenarioLoadedAction = scenario => {
  return {
    type: CONTENT_ACTIONS.DATA_SCENARIO_LOADED,
    payload: scenario
  };
};

const dataScenarioClearedAction = () => {
  return {
    type: CONTENT_ACTIONS.DATA_SCENARIO_LOADED,
    payload: undefined
  };
};

const calendarEventsLoadedAction = eventsByType => {
  return {
    type: CONTENT_ACTIONS.CALENDAR_EVENTS_LOADED,
    payload: eventsByType
  };
};

const screenDesignerModeUpdated = mode => {
  return {
    type: CONTENT_ACTIONS.SCREEN_DESIGNER_MODE,
    payload: mode
  };
};

const screenDesignerContentUpdated = content => {
  return {
    type: CONTENT_ACTIONS.SCREEN_DESIGNER_CONTENT,
    payload: content
  };
};

const customRouteModeUpdated = mode => {
  return {
    type: CONTENT_ACTIONS.CUSTOM_ROUTE_MODE,
    payload: mode
  };
};

const customRouteContentUpdated = content => {
  return {
    type: CONTENT_ACTIONS.CUSTOM_ROUTE_CONTENT,
    payload: content
  };
};

const contentTypesLoadedAction = types => {
  return {
    type: CONTENT_ACTIONS.CONTENT_TYPES_LOADED,
    payload: types
  };
};

const appThemesLoadedAction = themes => {
  return {
    type: CONTENT_ACTIONS.APP_THEMES_LOADED,
    payload: themes
  };
};

const contentModelsLoadedAction = models => {
  return {
    type: CONTENT_ACTIONS.CONTENT_MODELS_LOADED,
    payload: models
  };
};

const contentTypeUpdatedAction = contentType => {
  return {
    type: CONTENT_ACTIONS.CONTENT_TYPE_UPDATED,
    payload: contentType
  };
};

const contentTypesUpdatedAction = () => {
  return {
    type: CONTENT_ACTIONS.CONTENT_TYPES_UPDATED,
    payload: {}
  };
};

const contentReadOnlyModeAction = () => {
  return {
    type: CONTENT_ACTIONS.CONTENT_READONLY_MODE,
    payload: {}
  };
};

const contentEditModeAction = () => {
  return {
    type: CONTENT_ACTIONS.CONTENT_EDIT_MODE,
    payload: {}
  };
};

export {
  CONTENT_ACTIONS,
  contentTypesLoadedAction,
  contentTypesUpdatedAction,
  contentTypeUpdatedAction,
  contentReadOnlyModeAction,
  contentEditModeAction,
  contentModelsLoadedAction,
  calendarEventsLoadedAction,
  appThemesLoadedAction,
  screenDesignerModeUpdated,
  screenDesignerContentUpdated,
  customRouteModeUpdated,
  customRouteContentUpdated,
  dataScenarioClearedAction,
  dataScenarioLoadedAction,
  insertCodeEditorContentAction,
  clearCodeEditorInsertAction,
  codeEditorInsertRequested
};
